import { render, staticRenderFns } from "./MarketStatus.vue?vue&type=template&id=0b9eba3e&scoped=true"
import script from "./MarketStatus.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketStatus.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MarketStatus.vue?vue&type=style&index=0&id=0b9eba3e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9eba3e",
  null
  
)

export default component.exports